<div class="row">
  <div class="col-md-12">
    <agm-map [zoom]="16" [latitude]="location_lat" [longitude]="location_long">
      <agm-marker *ngIf="location_name != ''" [latitude]="location_lat" [longitude]="location_long">
        <agm-info-window [isOpen]="true">{{location_name}} <br /> Latitude: {{ location_lat }} - Longitude:
          {{location_long}} </agm-info-window>
      </agm-marker>
    </agm-map>
  </div>
</div>